import { Button, buttonVariants } from "@loot-os/ui/components/button";
import { Input } from "@loot-os/ui/components/input";
import { Label } from "@loot-os/ui/components/label";
import { Link } from "@tanstack/react-router";
import { useState } from "react";

import { AuthPageLayout } from "../components/AuthPageLayout";
import { useRequestPasswordResetMutation } from "../lib/authQueries";

export function ForgotPasswordPage() {
  const requestReset = useRequestPasswordResetMutation();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await requestReset.mutateAsync({ email });
      setSent(true);
    } catch {
      // The query client has already toasted the failure.
    }
  };

  if (sent) {
    return (
      <AuthPageLayout title="Check your email">
        {/* The same text for every email: the server's response does not say which exist. */}
        <p className="text-sm">
          If an account exists for that email, we sent a link to reset your password. It expires in
          1 hour.
        </p>
        <Link to="/login" className={buttonVariants({ variant: "outline", className: "w-full" })}>
          Back to sign in
        </Link>
      </AuthPageLayout>
    );
  }

  return (
    <AuthPageLayout title="Reset your password">
      <form onSubmit={submit} className="grid gap-4">
        <div className="grid gap-2">
          <Label htmlFor="forgot-email">Email</Label>
          <Input
            id="forgot-email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <Button type="submit" className="w-full" disabled={requestReset.isPending}>
          {requestReset.isPending ? "Sending…" : "Send reset link"}
        </Button>
      </form>
      <Link
        to="/login"
        className="justify-self-center text-sm text-muted-foreground underline-offset-4 hover:text-foreground hover:underline"
      >
        Back to sign in
      </Link>
    </AuthPageLayout>
  );
}
